/* @ngInject */
function UserFactory($http, $rootScope, Organization) {
  class User {
    constructor(data) {
      if (data) {
        angular.extend(this, data);
        this.organizations = this.organizations
          ? this.organizations.map(
              (organization) => new Organization(organization)
            )
          : null;
      }
    }

    static getTeam(params) {
      return $http
        .get(
          `${process.env.SERVER_URL}/api/secure/organization/${$rootScope.organization.slug}/team`,
          { params }
        )
        .then((response) =>
          response.data.map((userData) => new User(userData))
        );
    }

    static get() {
      return $http
        .get(`${process.env.SERVER_URL}/api/secure/user`)
        .then((response) => new User(response.data));
    }

    static create(
      name,
      surname,
      email,
      password,
      newsletter,
      discounts,
      locale
    ) {
      return $http
        .post(`${process.env.SERVER_URL}/api/public/user`, {
          name,
          surname,
          email,
          password,
          newsletter,
          discounts,
          locale,
        })
        .then((response) => new User(response.data));
    }

    static createByGoogle(googleToken, newsletter, discounts, locale) {
      return $http
        .post(`${process.env.SERVER_URL}/api/public/user`, {
          googleToken,
          newsletter,
          discounts,
          locale,
        })
        .then((response) => new User(response.data));
    }

    static resetPassword(email) {
      return $http.post(
        `${process.env.SERVER_URL}/api/public/user/reset/password`,
        { email }
      );
    }

    static verifyResetPassword(verificationResetPasswordToken, newPassword) {
      return $http.post(
        `${process.env.SERVER_URL}/api/public/user/reset/verify-password`,
        {
          verificationResetPasswordToken,
          newPassword,
        }
      );
    }

    static updateDefaultOrganization(defaultOrganizationId) {
      return $http
        .put(`${process.env.SERVER_URL}/api/secure/user/default-organization`, {
          defaultOrganizationId,
        })
        .then((response) => new User(response.data));
    }

    hasOrganization(organizationSlug) {
      if (!this.organizations) return false;

      return this.organizations.some(
        (organization) => organization.slug === organizationSlug
      );
    }

    getOrganization(organizationSlug) {
      if (!this.organizations) return null;

      for (const organization of this.organizations) {
        if (organization.slug === organizationSlug) {
          return organization instanceof Organization
            ? organization
            : new Organization(organization);
        }
      }

      return null;
    }

    hasOrganizations() {
      return this.organizations && this.organizations.length > 0;
    }

    hasPicture() {
      return Boolean(this.profileImg);
    }

    update(data) {
      return $http
        .put(`${process.env.SERVER_URL}/api/secure/user`, data)
        .then((response) => angular.extend(this, response.data));
    }

    updateProfileImage(imgMetadata) {
      return $http
        .post(`${process.env.SERVER_URL}/api/secure/user/picture`, {
          imgMetadata: imgMetadata || null,
        })
        .then((response) => angular.extend(this, response.data));
    }

    static signOut() {
      return $http
        .put(`${process.env.SERVER_URL}/api/secure/user/sign-out`)
        .then((response) => angular.extend(this, response.data))
        .catch((e) => {
          if (e.status !== 401) throw e;
        });
    }
  }

  return User;
}

export default UserFactory;
